module.exports = ".context-menu-icon {\n    cursor: pointer;\n}\n /deep/ .dx-page-sizes>#refresh {\n    float: right;\n    height: 33px;\n    vertical-align: bottom;\n}\n /deep/ baf-data-view-grid>#refresh {\n    float: left;\n    height: 33px;\n    vertical-align: bottom;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/data-view-grid/data-view-grid.component.css
// module id = ./src/app/components/data-view-grid/data-view-grid.component.css
// module chunks = main